import React from 'react'

export interface CurrencyInputProps {
  onChange: (value: string) => void
  onEnter: () => void
  className: string
  value?: string
  disabled?: boolean
}

export const formatValue = (value: string) => {
  const onlyNumbers = value.replace(/[^0-9]/g, '')
  if (onlyNumbers === '') return ''

  const dollars = parseInt(onlyNumbers, 10) / 100
  const formmatedDollars = dollars.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  return formmatedDollars
}

export function CurrencyInput({
  className,
  onChange,
  onEnter,
  value,
  disabled,
}: CurrencyInputProps) {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      onEnter()
    }
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = event.target.value.replace('$', '')
    const formatted = formatValue(rawValue)
    onChange(formatted)
  }

  return (
    <div className={className}>
      <span>$</span>
      <input
        type="text"
        value={value ?? ''}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        data-testid="currency-input"
        style={{ width: '90%' }}
        disabled={disabled}
        inputMode="decimal"
      />
    </div>
  )
}

export default CurrencyInput
